import GlobalStore from "../services/GlobalStore";
import { Video } from "../services/Video";
import { Application, Container, EventEmitter, Sprite } from "pixi.js";

type SceneProps = {
  app: Application;
  name: string;
  bgVideoPath?: string;
  bgImagePath?: string;
};

class Scene {
  app: Application;
  name: string;
  visible: boolean;

  protected bgContainer: Container = new Container();
  protected contentContainer: Container = new Container();

  bgImage: Sprite | undefined = undefined;
  bgVideo: Video | undefined = undefined;
  bgVideoLoaded: boolean = false;
  topZ: number = 2;

  constructor({ app, name, bgVideoPath, bgImagePath }: SceneProps) {
    this.app = app;
    this.name = name;
    this.visible = false;

    app.stage.addChild(this.bgContainer);
    GlobalStore.layers.background.attach(this.bgContainer);
    this.bgContainer.visible = this.visible;

    app.stage.addChild(this.contentContainer);
    GlobalStore.layers.content.attach(this.contentContainer);
    this.contentContainer.visible = this.visible;

    if (bgImagePath !== undefined) {
      this.loadBgImage(bgImagePath).then(() => {
        if (this.bgImage !== undefined) {
          // this.bgImage.width = app.screen.width;
          // this.bgImage.height = app.screen.height;
          // this.bgImage.visible = this.visible;
          this.bgContainer.addChild(this.bgImage);

          // this.bgImage.zIndex = 0;
        }
      });
    }

    if (bgVideoPath !== undefined) {
      this.loadBgVideo(bgVideoPath).then(() => {
        if (this.bgVideo !== undefined) {
          this.bgVideoLoaded = true;
          this.bgVideo.width = app.screen.width;
          this.bgVideo.height = app.screen.height;
          this.bgVideo.visible = false;
          this.bgVideo.volume = 0;
          this.bgContainer.addChild(this.bgVideo);

          if (this.visible) {
            this.bgVideo.visible = true;
            this.bgVideo.play();
          }

          // this.bgVideo.zIndex = 1;
        }
      });
    }
  }

  show() {
    if (this.visible) return;

    this.visible = true;

    this.bgContainer.visible = true;
    this.contentContainer.visible = true;

    if (this.bgVideo) {
      this.bgVideo.volume = 0.25;
      // this.bgVideo.visible = true;
      this.bgVideo.play();
    }
    console.log(`Scene ${this.name} is shown`);
  }

  hide() {
    if (!this.visible) return;

    this.visible = false;
    this.bgContainer.visible = false;
    this.contentContainer.visible = false;

    if (this.bgVideo) {
      this.bgVideo.stop();
      // this.bgVideo.visible = false;
    }

    console.log(`Scene ${this.name} is hidden`);
  }

  async loadBgVideo(path: string) {
    // this.bgVideo = new Video({
    //   texture: await Assets.load(path),
    // });
    this.bgVideo = Video.fromAlias(path);
  }

  async loadBgImage(path: string) {
    console.log(`Loading sprite from ${path}`);
    this.bgImage = Sprite.from(path);
    // this.bgImage = Sprite.from(await Assets.load(path));
  }

  destroy() {
    this.app.stage.removeChild(this.bgContainer);
    this.app.stage.removeChild(this.contentContainer);
  }
}

export default Scene;
